<template>
  <v-btn flat fab small
         @click="$emit('click')"
         class="ma-1 pl-0 pr-0 mr-2"
         :disabled="disabled"
         :loading="loading">
    <img class="align-center cursor-pointer"
         v-if="!disabled"
         height="38" width="38"
         :src="qbImageButton"
         @mouseover="qbImageButton = qbImageHover"
         @mouseleave="qbImageButton = qbImage"/>
    <img :src="qbImageButtonDisabled"
         height="38" width="38"
         class="align-center" v-else>
  </v-btn>
</template>

<script>
import QuickbooksMixin from '@/mixins/quickbooksMixin';

export default {
  name: 'VQuickbooksBtn',
  mixins: [QuickbooksMixin],
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qbImage: '/static/C2QB_white_btn_sm_default.png',
      qbImageHover: '/static/C2QB_white_btn_sm_hover.png',
      qbImageButtonDisabled: '/static/C2QB_white_btn_sm_disabled.png',
      qbImageButton: null,
    };
  },
  methods: {
  },
  created() {
    this.qbImageButton = this.qbImage;
  },
};
</script>




// WEBPACK FOOTER //
// src/components/qb/QuickbooksButton.vue